import type { IconDefinition } from "@fullscript/fontawesome-common-types";

import { NoStyleButton, type NoStyleButtonProps } from "@aviary/components/Button";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";

import * as styles from "./ToolbarButton.styles";

interface Props extends NoStyleButtonProps {
  icon: IconDefinition;
  isActive?: boolean;
}

const ToolbarButton = ({ icon, isActive, ...rest }: Props) => {
  return (
    <NoStyleButton css={[styles.toolbarBtn.base, isActive && styles.toolbarBtn.active]} {...rest}>
      <FontAwesomeIcon icon={icon} />
    </NoStyleButton>
  );
};

ToolbarButton.displayName = "RichTextEditor.ToolbarButton";

export { ToolbarButton };
